module.exports = __webpack_public_path__ + "img/img20.961a98a4.svg";